import { graphConfig } from 'msConfig';
import { chunkArray, wait } from 'helpers/AppHelpers';

const DEFAULT_CALENDAR_NAME = 'Team Members';
const MAX_BATCH_SIZE = 20;

export const microsoftGraphAPI = (msGraphClient) => {
  const getAllEventsFromMsGraph = async (calendarId) => {
    const url = `${graphConfig.calendarsEndpoint}/${calendarId}/events?$top=10000`;

    try {
      const { data, status } = await msGraphClient.get(url);

      if (status !== 200) {
        console.warn(`Failed to get events. Status code: ${status}`);
        throw new Error('Failed to get events');
      }

      return data.value || [];
    } catch (err) {
      console.error('Error getting events from MS Graph:', err?.message || err);
      throw new Error(`Error getting events: ${err.message}`);
    }
  };

  const createCalendarOnMsGraph = async () => {
    const query = { name: DEFAULT_CALENDAR_NAME, isDefaultCalendar: true };

    try {
      const { data, status } = await msGraphClient.post(graphConfig.calendarsEndpoint, query);

      if (status !== 201) {
        console.warn(`Failed to create calendar "${DEFAULT_CALENDAR_NAME}". Status: ${status}`);
        return null;
      }

      return data.id;
    } catch (err) {
      console.error('Error creating calendar on MS Graph:', err);
      throw new Error('Error creating calendar on MS Graph');
    }
  };

  const getCalendars = async () => {
    try {
      const { data } = await msGraphClient.get(graphConfig.calendarsEndpoint);
      return data.value || [];
    } catch (err) {
      console.error('Failed to fetch calendars:', err);
      throw new Error(`Failed to fetch calendars: ${err.message}`);
    }
  };

  const getCalendarId = async () => {
    try {
      const calendars = await getCalendars();
      const foundCalendar = calendars.find((item) => item.name === DEFAULT_CALENDAR_NAME);

      return foundCalendar?.id || (await createCalendarOnMsGraph());
    } catch (err) {
      console.error('Error while getting team members calendar id:', err);
      throw new Error(`Failed to get calendar id: ${err.message}`);
    }
  };

  const getMicrosoftEvents = async (calendarId) => {
    try {
      const events = await getAllEventsFromMsGraph(calendarId);
      return { calendarId, events };
    } catch (err) {
      console.error('Error while getting calendar events:', err);
      throw new Error(`Failed to get calendar events: ${err.message}`);
    }
  };

  const sendEventsInBatch = async (requests) => {
    const sendChunk = async (chunk) => {
      try {
        const requestsBody = { requests: chunk };

        const response = await msGraphClient.post(graphConfig.batchEndpoint, requestsBody);
        console.log('Batch sent successfully:', response.data);
      } catch (err) {
        console.error('Error sending batch:', err);
        throw new Error(`Failed to send batch: ${err.message}`);
      }
    };

    const chunks = chunkArray(requests, MAX_BATCH_SIZE);

    for (let i = 0; i < chunks.length; i = i + 1) {
      console.log(`Sending chunk ${i + 1}...`);
      await sendChunk(chunks[i]);
      await wait(2000);
    }
  };

  return { getCalendarId, getMicrosoftEvents, sendEventsInBatch };
};
